import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { useRefineDraft } from "@/features/eop_mail/api/mailbox";
import { extractError } from "./sanitize";

/**
 * „Redaguj AI" — model ubiera szkic w porządną formę, NICZEGO nie zmieniając
 * merytorycznie. Serwer sprawdza po fakcie, że liczby i numery przetrwały
 * co do znaku; jeśli nie — wraca oryginał i widać dlaczego.
 */
export function RefineButton({
  body,
  onRefined,
  disabled,
}: {
  body: string;
  onRefined: (html: string) => void;
  disabled?: boolean;
}) {
  const refine = useRefineDraft();
  const [mode, setMode] = useState<"standard" | "formal">("standard");
  const [note, setNote] = useState("");

  const run = () => {
    setNote("");
    refine.mutate(
      { body_html: body, mode },
      {
        onSuccess: (result) => {
          if (result.changed) onRefined(result.body_html);
          if (result.note) setNote(result.note);
        },
        onError: (err) => setNote(extractError(err)),
      },
    );
  };

  return (
    <span className="inline-flex items-center gap-2">
      <select
        value={mode}
        onChange={(e) => setMode(e.target.value as "standard" | "formal")}
        className="border border-[var(--color-border-strong)] bg-[var(--color-bg-surface)] px-2 py-1.5 text-xs text-[var(--color-text-secondary)]"
        title="Styl redakcji"
      >
        <option value="standard">standardowy</option>
        <option value="formal">formalny</option>
      </select>
      <Button
        variant="secondary"
        size="sm"
        onClick={run}
        loading={refine.isPending}
        disabled={disabled || !body.trim()}
        title="AI poprawia wyłącznie formę — liczby, numery i terminy zostają co do znaku."
      >
        <Sparkles size={13} className="mr-1" />
        Redaguj AI
      </Button>
      {note && (
        <span className="text-[11px] text-[var(--color-text-muted)]">{note}</span>
      )}
    </span>
  );
}
